import { makeRequest } from 'utils/requestLogger';

// This endpoint deletes a student participation and denies them access to the live discussion.
// Student is kicked out
export default (discussionId, studentId) =>
  makeRequest(
    'delete',
    `/api/live_discussions/${discussionId}/remove-student/${studentId}`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/removeStudent.js